export type EnglishJoinConfig = {
  /** Used to join the final word onto the list @default 'or'. */
  finalSeparator?: '&' | 'or';
};

export function englishJoin(
  words: string[],
  {
    finalSeparator = 'or'
  }: EnglishJoinConfig = {}
): string {
  if (words.length < 2) {
    return words[0] ?? '';
  }

  const oxfordComma = (words.length < 3) ? '' : ',';

  return (
    words.slice(0, words.length - 1).join(', ')
    + `${oxfordComma} ${finalSeparator} ${words[words.length - 1]}`
  );
}
